/**
 * 런타임 클라이언트 설정 (`/meta/client` · DESIGN §8.2.1 규칙 3).
 *
 * manifest 의 features 는 **빌드 시점**의 판정이다. 그 뒤 경계 파일을 넣거나 키가
 * 만료되면 값이 달라지므로, 레이어를 켤지 말지는 지금 판정한 값으로 정해야 한다.
 *
 * 꺼진 기능을 목록에서 지우지 않는 것이 이 훅의 존재 이유다 — 사라진 레이어는
 * "없는 기능"과 구별되지 않는다.
 */

import { useQuery } from '@tanstack/react-query'

import { fetchPlain } from './api'
import type { ClientConfig } from './types'

export function useClientConfig() {
  return useQuery({
    queryKey: ['meta', 'client'],
    queryFn: ({ signal }) => fetchPlain<ClientConfig>('/meta/client', signal),
    staleTime: 60 * 1000,
  })
}

/** 기능이 꺼진 이유 한 문장. 없으면 null (= 켜져 있다). */
export function disabledReason(
  config: ClientConfig | undefined,
  feature: string,
): string | null {
  if (!config) return null
  if (config.features[feature]) return null
  const line = config.downgrades.find((d) => d.includes(`features.${feature}`))
  if (line) {
    // "게이트 D7 미충족으로 features.choropleth 강등 — 사유" → 사유 부분만
    const dash = line.indexOf('—')
    const gate = line.match(/게이트\s+(D\d+)/)?.[1]
    const why = dash >= 0 ? line.slice(dash + 1).trim() : line
    return gate ? `게이트 ${gate}: ${why}` : why
  }
  return '설정에서 꺼져 있습니다'
}
